var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.548,
    height: 26.548,
    viewBox: "0 0 26.548 26.548",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2400",
    "data-name": "Group 2400",
    transform: "translate(0.599 0.599)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_17639_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_17642_",
    cx: 10.582,
    cy: 10.582,
    r: 10.582,
    transform: "translate(0 4.72) rotate(-12.886)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_17640_",
    transform: "translate(8.157 9.29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17641_",
    d: "M408,2276.43l3.608,3.225,5.865-7.155",
    transform: "translate(-408 -2272.5)",
    fill: "none",
    stroke: "#178e00",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/Correct.92a4d8b62348ec3ef4baa28fd27f5b7d.svg";
export { ForwardRef as ReactComponent };